import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommunityLink } from '../../interfaces';
import { ConfigurationService } from '../util/configuration.service';
import { CommunityLinksStrategy } from './community-links-strategy.interface';

@Injectable({ providedIn: 'root' })
export class UserLinksStrategy implements CommunityLinksStrategy {
  private configurationService = inject(ConfigurationService);

  loadLinks(userId: string): Observable<CommunityLink[]> {
    return this.configurationService.getCachedConfiguration(userId).pipe(map(items => items.links));
  }
}
